(function() {
	'use strict';

	angular
		.module('pwc.controllers')
		.controller('WineSaleDialogController', WineSaleDialogController);

	WineSaleDialogController.$inject = ['$window', '$mdDialog', 'WineSale', 'userPouch', 'wine', 'lodash', '$log', 'transaction', 'combinedHistoryIndex', 'MessageService', 'persistOnSave', '$timeout', '$rootScope', 'ENV'];

	function WineSaleDialogController($window, $mdDialog, WineSale, userPouch, wine, lodash, $log, transaction, combinedHistoryIndex, MessageService, persistOnSave, $timeout, $rootScope, ENV){

		/* jshint validthis: true */
		var self = this;

		self.wine = wine;

		self.sale = null;

		self.maxBottles = lodash.get(wine, 'cellar.qty');

		self.isEdit = false;

		self.persistOnSave = persistOnSave;

		self.save = save;
		self.closeDialog = closeDialog;
		self.localeSymbol = ENV.LOCALE_SYMBOL;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			if (lodash.isNotEmptyOrNull(transaction)){
				// angular datepicker wants js Date
				// @TODO fix with $mdDateLocaleProvider?
				$timeout(function() {
					transaction.date = lodash.isNotEmptyOrNull(transaction.date) ? $window.moment(transaction.date).toDate() : null;
					self.sale = transaction;
				});

				self.isEdit = true;

				// adjust max bottle limit
				self.maxBottles = lodash.add(lodash.get(wine, 'cellar.qty'), transaction.qty);

			} else {
				self.sale = new WineSale();
			}
		}

		function save(){
			$log.debug('Saving transaction...');

			// @TODO add preUpdate event & handler?

			self.sale.qty = lodash.parseInt(self.sale.qty);

			self.wine.upsertCombinedHistoryItem(self.sale, combinedHistoryIndex);

			if (persistOnSave){
				return _persist();
			} else {
				closeDialog();
				$rootScope.$emit('WineTransactionAddedButNotSaved');
				_showPostSaveToast();
			}
		}

		function closeDialog(){
			return $mdDialog.hide();
		}

		function _showPostSaveToast(){
			var msg = "Sale " + (self.isEdit ? 'Updated' : 'Added') + ". Don't forget to save when done editing.";

			return MessageService.showToast(msg, 5000);
		}

		function _persist(){
			userPouch
				.save(self.wine)
				.then(function(){
					return MessageService.showToast('Sale saved!', 5000);
				})
				.then(closeDialog)
				.catch(function(err){
					$log.error('Error saving wine.', err);
					MessageService.showToast('Unable to save. Please contact support if problem persists', 5000);
				});
		}

	}

})();
